import { SyncState } from '@sonar-software/xuder';

export type SonarFollowedIdMapState = SyncState<Record<number, boolean>>;

export const defaultFollowedIdMapState: SonarFollowedIdMapState = { data: {} };
